import { Helmet } from "react-helmet-async";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import { Container, Typography, Card, Tabs, Tab, Box } from "@mui/material";

const TAB_ROUTES = [
  { label: "Areas", value: "/dashboard/areas-countries/areas" },
  { label: "Countries", value: "/dashboard/areas-countries/countries" },
];

export default function AreasCountriesPage() {
  const location = useLocation();
  const activeTab =
    TAB_ROUTES.find((tab) => location.pathname.startsWith(tab.value))?.value ??
    TAB_ROUTES[0].value;

  return (
    <>
      <Helmet>
        <title>Areas & Countries | DreamTeam Admin</title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 3 }}>
          Areas & Countries
        </Typography>

        <Card>
          <Box sx={{ px: 3, pt: 2 }}>
            <Tabs value={activeTab} aria-label="Areas and Countries tabs">
              {TAB_ROUTES.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  component={RouterLink}
                  to={tab.value}
                />
              ))}
            </Tabs>
          </Box>
          <Box sx={{ p: 3 }}>
            <Outlet />
          </Box>
        </Card>
      </Container>
    </>
  );
}
